import { overallIdentity } from './identityContext';

const outcomeOrder = { likely_match: 0, possible_match: 1, unavailable: 2, likely_false_positive: 3 };
const strengthOrder = { strong: 0, moderate: 1, weak: 2 };
const nameScore = value => {
  if (value == null || value === '') return -1;
  const score = Number(value);
  return Number.isFinite(score) ? (score > 1 ? score / 100 : score) : -1;
};

// Called for one subject's evidence list. Assessment batches are published
// together; do not reorder a partially assessed list. Missing/failed context is
// terminal (unavailable), unlike an explicitly pending assessment.
export function orderScreeningHits(hits, assessmentFor) {
  const entries = hits.map((hit, index) => {
    const assessment = assessmentFor(hit);
    return { hit, index, ...assessment, outcome: overallIdentity(assessment.strength, assessment.context).outcome };
  });
  if (entries.some(entry => entry.context?.status === 'pending')) return hits;

  const ordered = entries.filter(entry => entry.outcome !== 'not_applicable').sort((a, b) =>
    outcomeOrder[a.outcome] - outcomeOrder[b.outcome] ||
    (strengthOrder[a.strength] ?? 3) - (strengthOrder[b.strength] ?? 3) ||
    nameScore(b.score) - nameScore(a.score) || a.index - b.index
  );
  // Entity/personal-context-not-applicable rows retain their original positions.
  let next = 0;
  return entries.map(entry => entry.outcome === 'not_applicable' ? entry.hit : ordered[next++].hit);
}
